// extracted by mini-css-extract-plugin
module.exports = {"root":"EventMarketingDetailsModal_root__BfWxw","label":"EventMarketingDetailsModal_label__2jWgl","value":"EventMarketingDetailsModal_value__1GqLu"};